/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlatformAnalyticsTrendPoint
 */
export interface PlatformAnalyticsTrendPoint {
    /**
     * Calendar date as YYYYMMDD integer (UTC)
     * @type {number}
     * @memberof PlatformAnalyticsTrendPoint
     */
    date: number;
    /**
     * 
     * @type {number}
     * @memberof PlatformAnalyticsTrendPoint
     */
    impression: number;
    /**
     * 
     * @type {number}
     * @memberof PlatformAnalyticsTrendPoint
     */
    click: number;
    /**
     * 
     * @type {number}
     * @memberof PlatformAnalyticsTrendPoint
     */
    complete: number;
    /**
     * 
     * @type {number}
     * @memberof PlatformAnalyticsTrendPoint
     */
    claim: number;
    /**
     * 
     * @type {number}
     * @memberof PlatformAnalyticsTrendPoint
     */
    participate: number;
}

/**
 * Check if a given object implements the PlatformAnalyticsTrendPoint interface.
 */
export function instanceOfPlatformAnalyticsTrendPoint(value: object): value is PlatformAnalyticsTrendPoint {
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('impression' in value) || value['impression'] === undefined) return false;
    if (!('click' in value) || value['click'] === undefined) return false;
    if (!('complete' in value) || value['complete'] === undefined) return false;
    if (!('claim' in value) || value['claim'] === undefined) return false;
    if (!('participate' in value) || value['participate'] === undefined) return false;
    return true;
}

export function PlatformAnalyticsTrendPointFromJSON(json: any): PlatformAnalyticsTrendPoint {
    return PlatformAnalyticsTrendPointFromJSONTyped(json, false);
}

export function PlatformAnalyticsTrendPointFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlatformAnalyticsTrendPoint {
    if (json == null) {
        return json;
    }
    return {
        
        'date': json['date'],
        'impression': json['impression'],
        'click': json['click'],
        'complete': json['complete'],
        'claim': json['claim'],
        'participate': json['participate'],
    };
}

export function PlatformAnalyticsTrendPointToJSON(json: any): PlatformAnalyticsTrendPoint {
    return PlatformAnalyticsTrendPointToJSONTyped(json, false);
}

export function PlatformAnalyticsTrendPointToJSONTyped(value?: PlatformAnalyticsTrendPoint | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date': value['date'],
        'impression': value['impression'],
        'click': value['click'],
        'complete': value['complete'],
        'claim': value['claim'],
        'participate': value['participate'],
    };
}

